import React from 'react';

/**
 * The `SidenavItem` component is used to display a single item in the sidenav.
 *
 * @example
 * ```html
 * <SidenavItem>
 *   <a href="#">Home</a>
 * </SidenavItem>
 *
 * <SidenavItem>
 *   <button>Foo</button>
 *   <SidenavSection subnav>
 *     <SidenavItem><a href="#">Nested Link</a></SidenavItem>
 *   </SidenavSection>
 * </SidenavItem>
 * ```
 */
function SidenavItem({ children, className, selected, }) {
    const selectedProps = selected ? { selected: true } : {};
    return (React.createElement("tds-sidenav-item", { class: className, ...selectedProps }, children));
}

export { SidenavItem };
//# sourceMappingURL=SidenavItem.js.map
